import { useEffect, useState } from "react";

/**
 * 스크롤 위치를 기준으로 현재 화면에 들어와 있는 섹션 id를 추적한다.
 * - 상단 고정 헤더에 가려지는 영역을 고려해 offset(px) 만큼 아래 지점을 기준선으로 삼는다.
 * - getBoundingClientRect 기반이라 섹션의 offsetParent 구조와 무관하게 동작한다.
 */
export function useActiveSection(ids: readonly string[], offset = 140) {
  const [activeId, setActiveId] = useState<string>("");

  useEffect(() => {
    if (ids.length === 0) return undefined;

    const handleScroll = () => {
      let current = "";
      for (const id of ids) {
        const el = document.getElementById(id);
        if (!el) continue;
        const top = el.getBoundingClientRect().top;
        if (top <= offset) {
          current = id;
        }
      }
      setActiveId((prev) => (prev === current ? prev : current));
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
    // ids 참조가 매 렌더마다 바뀌어도 재구독되지 않도록 문자열 키로 의존성을 관리한다.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ids.join("|"), offset]);

  return activeId;
}